<h1 mat-dialog-title>Archived models</h1>
<mat-dialog-content>
  <p class="intro">Archived models are hidden from the organisation, and deleted {{expiryDays}} days after being archived. Restore them to use them again, or delete them permanently now.</p>
  @if (datasource.data.length === 0) {
    <p class="empty">There are no archived models.</p>
  }@else {
    <div class="table-container">
      <table mat-table [dataSource]="datasource">
        @for (column of modelColumns; track column; let i = $index) {
          <ng-container matColumnDef="{{column}}">
            <th mat-header-cell *matHeaderCellDef>
              @if (column === 'select') {
                <mat-checkbox (change)="toggleAll()" [checked]="isAllSelected()" [indeterminate]="selection.hasValue() && !isAllSelected()" aria-label="Select all models"></mat-checkbox>
              }@else {
                {{modelColumnHeadings[i]}}
              }
            </th>
            <td mat-cell *matCellDef="let row">
              @if (column === 'select') {
                <mat-checkbox (click)="$event.stopPropagation()" (change)="selection.toggle(row)" [checked]="selection.isSelected(row)" [attr.aria-label]="'Select ' + row.name"></mat-checkbox>
              }@else if (column === 'createdDate' || column === 'deletedDate') {
                {{row[column] | date}}
              }@else {
                {{row[column]}}
              }
            </td>
          </ng-container>
        }
        <tr mat-header-row *matHeaderRowDef="modelColumns; sticky: true"></tr>
        <tr mat-row [id]="row._key" (click)="selectRow(row)" *matRowDef="let row; columns: modelColumns;" [class.selected]="selection.isSelected(row)"></tr>
      </table>
    </div>
  }
</mat-dialog-content>
<div mat-dialog-actions class="actions">
  <span class="selected-count">{{selection.selected.length ? selection.selected.length + ' selected' : ''}}</span>
  <button mat-button (click)="onCancelClick()">Cancel</button>
  <button mat-stroked-button color="warn" (click)="deletePermanently()" [disabled]="!selection.hasValue()">
    <mat-icon>delete_forever</mat-icon>Delete permanently
  </button>
  <button mat-flat-button color="accent" cdkFocusInitial (click)="restore()" [disabled]="!selection.hasValue()">
    <mat-icon>unarchive</mat-icon>Restore
  </button>
</div>
